import { SpeedometerCard } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import ENV from '../../base/env';
import { IDomainCalculation } from '../../base/types';
import { MapDomainIds } from './constants';

export interface IProps extends IDomainCalculation {
  skeletonClass: string;
  index: number;
}

const ResultCard: React.FC<IProps> = ({ domainId, value, skeletonClass, index }) => {
  const { t } = useTranslation();
  const domainCode = MapDomainIds[domainId];
  const percent = Math.round(value / 100);
  const imageSrc = `${ENV.AssetsBaseUrl}/feature/icons/${domainCode}.png`;
  const domainTitle = t(`common:Domain.Title.${domainId}`);
  return (
    <div className="col-6 result-cards-item">
      <SpeedometerCard
        className={skeletonClass}
        gaugeMaxLabel={t('postreg:Evaluation.GaugeMax')}
        gaugeMinLabel={t('postreg:Evaluation.GaugeMin')}
        iconSrc={imageSrc}
        id={`${domainId}-${index}`}
        value={percent}
        title={`${domainTitle} ${percent}%`}
      />
    </div>
  );
};

export default ResultCard;
